module.exports = __webpack_public_path__ + "fonts/pt_root-ui_bold.f52fcf2.ttf";